<script setup>
import { computed, onBeforeUnmount, watch } from 'vue';
import {
  CONCLUSION_RESULT_OPTIONS,
  conclusionPromptState,
  chooseConclusionResult,
  cancelConclusionResult,
} from 'dashboard/composables/useConclusionResultPrompt';

const TITLE = 'Concluir atendimento';
const CANCEL_LABEL = 'Cancelar';

const description = computed(() =>
  conclusionPromptState.count > 1
    ? `Como terminaram estes ${conclusionPromptState.count} atendimentos?`
    : 'Como terminou este atendimento?'
);

const onKeydown = event => {
  if (event.key === 'Escape') cancelConclusionResult();
};

watch(
  () => conclusionPromptState.open,
  open => {
    if (open) window.addEventListener('keydown', onKeydown);
    else window.removeEventListener('keydown', onKeydown);
  }
);

onBeforeUnmount(() => window.removeEventListener('keydown', onKeydown));
</script>

<template>
  <Teleport to="body">
    <div
      v-if="conclusionPromptState.open"
      class="acl-conclusion-result-modal fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 px-4"
      @click.self="cancelConclusionResult"
    >
      <div
        role="dialog"
        aria-modal="true"
        class="w-full max-w-sm rounded-xl bg-n-solid-1 p-5 shadow-xl outline outline-1 outline-n-weak"
      >
        <h3 class="text-base font-semibold text-n-slate-12">
          {{ TITLE }}
        </h3>
        <p class="mt-1 text-sm text-n-slate-11">{{ description }}</p>
        <div class="mt-4 flex flex-col gap-2">
          <button
            v-for="option in CONCLUSION_RESULT_OPTIONS"
            :key="option.value"
            type="button"
            class="acl-conclusion-result-option w-full rounded-lg px-3 py-2.5 text-left text-sm font-medium text-n-slate-12 outline outline-1 outline-n-weak hover:bg-n-alpha-2"
            :data-conclusion-result="option.value"
            @click="chooseConclusionResult(option.value)"
          >
            {{ option.label }}
          </button>
        </div>
        <div class="mt-4 flex justify-end">
          <button
            type="button"
            class="acl-conclusion-result-cancel rounded-lg px-3 py-2 text-sm text-n-slate-11 hover:bg-n-alpha-2"
            @click="cancelConclusionResult"
          >
            {{ CANCEL_LABEL }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>
